import React, { useRef } from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";

import {
  useFetchProfilesQuery,
  useFetchSingleCustomAdvertiserQuery,
} from "../../store/api/apiSlice";

const baseUrl = process.env.REACT_APP_SERVER_URL;
const settings = {
  dots: true,
  infinite: false,
  speed: 500,
  loop: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow: null,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
      },
    },
    {
      breakpoint: 20,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
      },
    },
  ],
};
const AdvertisementSlider = () => {
  const { data: profileData } = useFetchProfilesQuery();
  const { data: singleCustomAdvertiser } = useFetchSingleCustomAdvertiserQuery(
    profileData?.user?.school_name,
    {
      skip: !profileData?.user?.school_name,
    }
  );

  const bannerAdvertisers =
    singleCustomAdvertiser?.advertisers?.filter(
      (advertiser) => advertiser.type === "banner"
    ) || [];

  const sliderRef = useRef(null);
  return (
    <div
      className="sliderdiv footbalNews_slider AdvertisementSlider"
      id="adscard"
    >
      {bannerAdvertisers.length > 0 ? (
        <>
          <Slider ref={sliderRef} {...settings}>
            {bannerAdvertisers.map((advertiser, index) => (
              <>
                <div key={advertiser.id || index} className="AdvertisementCard">
                  <Link
                    to={advertiser.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="AdvertisementLink"
                  >
                    <img
                      src={`${baseUrl}/${advertiser.bannerAdFile}`}
                      alt="Banner Ad"
                      className="AdvertisementImage"
                    />
                  </Link>

                  <Link
                    to={advertiser.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="AdvertisementTitleLink"
                  >
                    <h5 className="card-title text-center">
                      {advertiser.refName}
                    </h5>
                  </Link>
                </div>
              </>
            ))}
          </Slider>
        </>
      ) : (
        <p className="AdvertisementNoAds">No ads</p>
      )}
      <style jsx>{`
        .footbalNews_slider ul {
          bottom: -30px !important; /* Adjust the position of the dots */
        }

        .sliderdiv .slick-slider .slick-list {
          height: 150px !important;
        }
      `}</style>
    </div>
  );
};

export default AdvertisementSlider;
